import type { Content } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { renderChecklistBlock } from './blocks/checklistBlockRenderer';
import { renderGridBlockWithDivider } from './blocks/gridBlockRenderer';
import { renderKvBlock } from './blocks/kvBlockRenderer';
import { renderRowGroupBlock } from './blocks/rowGroupBlockRenderer';
import { renderSpacerBlock } from './blocks/spacerBlockRenderer';
import { renderTableBlock } from './blocks/tableBlockRenderer';
import { renderTextBlock } from './blocks/textBlockRenderer';
import { renderImageBlock } from './blocks/imageBlockRenderer';
import { renderScorecardChartBlock } from './blocks/scorecardChartBlockRenderer';

export function blockToContentForm(
  block: ViewBlock,
  options: { flattenRowGroups?: boolean } = {}
): Content {
  const { flattenRowGroups = false } = options;

  switch (block.type) {
    case 'text':
      return renderTextBlock(block);
    case 'kv':
      return renderKvBlock(block, { layout: 'formInner', marginBottom: 0 });
    case 'row-group':
      if (flattenRowGroups) {
        return renderKvBlock(
          { type: 'kv', items: block.rows.flatMap((row) => row.items) },
          { layout: 'formInner', marginBottom: 0 }
        );
      }

      return renderRowGroupBlock(block, {
        layout: 'formInner',
        marginBottom: 0,
      });
    case 'table':
      return renderTableBlock(block, { layout: 'formInner', marginBottom: 0 });
    case 'checklist':
      return renderChecklistBlock(block);
    case 'spacer':
      return renderSpacerBlock(block);
    case 'grid':
      return renderGridBlockWithDivider(block, (child) => blockToContentForm(child, options));
    case 'image':
      return renderImageBlock(block);
    case 'scorecard-chart':
      return renderScorecardChartBlock(block);
    default:
      return {
        text: '[Blocco non supportato]',
        style: 'bodyMuted',
      };
  }
}
